import React from "react";
import { GlobalContext } from "../../context/GlobalState";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import {getStateCityDetail as cityData} from "../../common/api";

import {
  Paper,
  Grid,
  Typography,
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from "@material-ui/core";
import AllCenterCode from "./AllCenterCode";

function UpdateCenterCode({ showData }) {
  const _id = showData._id;
  const [statesel, setStateSel] = React.useState(showData.state);
  const [citysel, setCitySel] = React.useState(showData.city);
  const [area, setArea] = React.useState(showData.area);
  const [centercd, setCentercd] = React.useState(showData.centerCode);
  const { allstatecity, getStateCityDetails, err } = React.useContext(GlobalContext);
  const { updateCenterCodeDetails } = React.useContext(GlobalContext);
  const [cityOptions, setCityOptions] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [status, setStatus] = React.useState(showData.status);
  const [back, setBack] = React.useState(false);

  const data = JSON.parse(JSON.stringify(allstatecity));

  const onSubmit = e => {
    e.preventDefault();

    const updatecentercode = {
      status,
      area: area,
      city: citysel,
      state: statesel,
      centerCode: centercd
    };
    updateCenterCodeDetails(updatecentercode);
    setOpen(true);
  };

  React.useEffect(() => {
	  getStateCityDetails();
    cityData().then(items => {
      let dataCity = JSON.parse(JSON.stringify(items));
      setCityOptions(dataCity[showData.state]);
    })
    setStateSel(showData.state);
    setCitySel(showData.city);
    setArea(showData.area);
    setCentercd(showData.centerCode);
    setCityOptions(data[showData.state]);
  }, []);

  const onChangeState = e => {
    const value = e.target.value ? e.target.value : "";
    setStateSel(value);
    setCityOptions(data[value]);
  };

  const onChangeUserCity = e => {
    setCitySel(e.target.value);
  };

  const handleClose = () => {
    setOpen(false);
    setBack(true);
  };

  if (back) {
    return <AllCenterCode />;
  }

  return (
    <React.Fragment>
      <Box pb={2}>
        <Button
          onClick={handleClose}
          type="submit"
          size="large"
          variant="contained"
          color="primary"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Box>

      <form onSubmit={onSubmit}>
        <Box boxShadow={3} mb={1}>
          <Grid container component={Paper}>
            <Grid item xs={12}>
              <Box p={2}>
                <Typography variant="h5">Update Center Code</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box px={2} my={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="select-state-name">Select State</InputLabel>
                  <Select
                    labelId="select-state-name"
                    id="demo-simple-select-filled"
                    value={statesel}
                    onChange={onChangeState}
                    name="state"
                    label="Select State"
                    required
                  >
                    {Object.keys(data).map(function(keyName) {
                      return (
                        <MenuItem key={keyName} value={keyName}>
                          {keyName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box px={2} my={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="select-city-name">Select City</InputLabel>
                  <Select
                    labelId="select-city-name"
                    id="demo-simple-select-filled1"
                    value={citysel}
                    onChange={onChangeUserCity}
                    name="city"
                    label="Select City"
                    required
                  >
                    {cityOptions && cityOptions.length
                      ? cityOptions.map(keyName => (
                          <MenuItem key={keyName} value={keyName}>
                            {keyName}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box px={2}>
                <TextField
                  label="area"
                  id=""
                  type="text"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={area}
                  onChange={e => setArea(e.target.value)}
                  name="area"
                  required
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box px={2}>
                <TextField
                  label="Center Code"
                  id=""
                  type="text"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={centercd}
                  onChange={e => setCentercd(e.target.value)}
                  name="centerCode"
                  required
                  disabled
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box px={2} my={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="select-state-name">Select Status</InputLabel>
                  <Select
                    labelId="select-state-name"
                    id="demo-simple-select-filled"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    name="state"
                    label="Select Status"
                    required
                  >
                     <MenuItem key={'Active'} value={'Active'}> {'Active'} </MenuItem>
                     <MenuItem key={'InActive'} value={'InActive'}> {'Inactive'} </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box p={2}>
                <Button
                  type="submit"
                  size="large"
                  pt={2}
                  variant="contained"
                  color="primary"
                >
                  Save
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </form>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          align="center"
          style={{ background: "antiquewhite" }}
          id="responsive-dialog-title"
        >
          {err ? err : "Center code details updated"}
        </DialogTitle>

        <DialogActions style={{ justifyContent: "center" }}>
          <Button onClick={handleClose} variant="contained" color="primary">
            Back
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default UpdateCenterCode;
